import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 128 128"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F0F0F0",
      d: "M64 128c35.346 0 64-28.654 64-64S99.346 0 64 0 0 28.654 0 64s28.654 64 64 64"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0052B4",
      d: "M13.228 25.035a63.8 63.8 0 0 0-11.025 22.27h33.295zM125.794 47.304a63.8 63.8 0 0 0-11.025-22.269L92.5 47.305zM2.203 80.697a63.8 63.8 0 0 0 11.025 22.269l22.269-22.269zM102.964 13.23A63.8 63.8 0 0 0 80.695 2.206V35.5zM25.031 114.77a63.8 63.8 0 0 0 22.27 11.026V92.502zM47.3 2.205A63.8 63.8 0 0 0 25.031 13.23L47.3 35.5zM80.695 125.796a63.8 63.8 0 0 0 22.269-11.025L80.695 92.502zM92.5 80.697l22.269 22.269a63.8 63.8 0 0 0 11.025-22.269z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D80027",
      d: "M127.458 55.652h-55.11V.542a64.6 64.6 0 0 0-16.696 0v55.11H.542a64.6 64.6 0 0 0 0 16.696h55.11v55.11a64.6 64.6 0 0 0 16.696 0v-55.11h55.11a64.6 64.6 0 0 0 0-16.696"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#D80027",
      d: "m80.695 80.696 28.559 28.559a64 64 0 0 0 3.762-4.109l-24.45-24.45zM47.301 80.695l-28.559 28.559a64 64 0 0 0 4.109 3.762l24.45-24.45zM47.305 47.304l-28.559-28.56a64 64 0 0 0-3.762 4.109l24.451 24.45zM80.695 47.306l28.56-28.56a64 64 0 0 0-4.109-3.762l-24.45 24.451z"
    }, null, -1)
  ])))
}
export default { render: render }